import React, { useState } from 'react';
import Card from '../components/Card';
import Filters from '../components/Filters';
import TagsHoc from '../components/hoc/TagsHoc';
import { useData } from '../context/DataContext';
import { useFavorites } from '../context/FavoritesContext';
import { RouteComponentProps } from 'react-router';
import { useQueryStrings } from '../context/QueryStringContext';
import { notFalsy, notUndefined, onlyUnique } from '../../../../../../../shared/lib/functional';

interface OfferPagePropsBase {}

type OfferPageProps = OfferPagePropsBase & RouteComponentProps;

function OffersPage(_props: OfferPageProps) {
  const { todayLineup, data } = useData();
  const [activeFilters, setActiveFilters] = useState<string[]>([]);
  const { favorites, toggleFavorite } = useFavorites();
  const { updateQs } = useQueryStrings();

  const filteredOffers = todayLineup.offers.filter(offer => {
    if (activeFilters.length === 0) return true;

    let filterCheck = true;

    activeFilters.forEach(filter => {
      switch (filter) {
        case data.appConfig.TRENDING_LABEL: {
          filterCheck = filterCheck && offer.isTrending;
        }
        default: {
          if (data.collections.offerTypes[filter]) {
            filterCheck =
              filterCheck && (offer.typeIds.length === 0 || offer.typeIds.includes(filter));
          } else if (data.collections.zones[filter]) {
            filterCheck =
              filterCheck && (offer.zoneIds.length === 0 || offer.zoneIds.includes(filter));
          }
          break;
        }
      }
    });

    return filterCheck;
  });

  const offerTypeKeys = todayLineup.offers
    .map(v => v.typeIds)
    .flat()
    .filter(notFalsy)
    .filter(onlyUnique);

  const zoneKeys = Object.keys(data.collections.zones).map(e => data.collections.zones[e]._id);

  return (
    <div id="OffersPage">
      <Filters
        title={data.appConfig.OFFERS_LABEL}
        icon={['far', 'hand-holding-circle-dollar']}
        staticButtons={[
          todayLineup.offers.find(o => o.isTrending) ? data.appConfig.TRENDING_LABEL : undefined,
        ].filter(notUndefined)}
        keys={[...zoneKeys, ...offerTypeKeys]}
        onFilterChange={setActiveFilters}
        labelExtractor={(key: string) =>
          data.collections.offerTypes[key]?.name || data.collections.zones[key]?.name
        }
        rightSide={
          <div className="flex items-center -mr-4">
            <div className="px-4 font-semibold date-picker">{data.appConfig.TODAY_LABEL}</div>
          </div>
        }
      />
      <div className="grid gap-2 pb-8">
        {filteredOffers.map(offer => (
          <TagsHoc type="basic" item={offer} key={offer.id}>
            {props => (
              <Card
                className="border-b"
                onClick={() => updateQs('offer', offer.id)}
                title={offer.title}
                subtitle={offer.description}
                image={offer.images[0]?.url}
                tags={props.tags}
                isFavorite={!!favorites.offers[offer.id]}
                onFavoriteClick={() => toggleFavorite({ type: 'offers', value: offer })}
              />
            )}
          </TagsHoc>
        ))}
        {filteredOffers.length <= 0 && (
          <div className="italic text-slate px-4 pt-4 text-center">
            {data.appConfig.NO_RESULTS_TEXT}
          </div>
        )}
      </div>
    </div>
  );
}
export default OffersPage;
